import { type FullPageEditorPresetAPI } from '@confluence/full-page-editor-store';
import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { useReadTime_content$key } from '../src/hooks/__generated__/useReadTime_content.graphql.ts';

type SendContentFeaturesProps = {
	contentId: string;
	contentType?: string | null;
	editorApi?: FullPageEditorPresetAPI | null;
	isInEditor?: boolean;
	isAbbreviatedReadTime?: boolean;
	isDetailsPanel?: boolean;
	showWordCount?: boolean;
	contentFragmentRef?: useReadTime_content$key | null;
};

export const ReadTime: LoadableType<SendContentFeaturesProps> =
	LoadableAfterPaint<SendContentFeaturesProps>({
		loader: async () =>
			(await import(/* webpackChunkName: "loadable-ReadTime" */ '../src/ReadTime.tsx')).ReadTime,
	});
